import React, { useEffect, useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import Select from "react-select";
import { UrlWs } from "../../utils/Global";

async function cargar() {
  const url =UrlWs+ "/officers/fea";
  /*if (localStorage.getItem(url) != null) {
    return JSON.parse(localStorage.getItem(url));
  }*/

  const opciones = await fetch(url)
    .then((response) => {
      if (response.status == 400) {
        return [];
      } else {
        return response.json();
      }
    })
    .then((datos) => {
      datos.unshift({
        id_officer: null,
        officerName: "Seleccione un precalificador",
      });
      const opciones = datos.map((d) => {
        return {
          value: d.id_officer,
          label: d.officerName,
        };
      });
      return opciones;
    });
    localStorage.setItem(url, JSON.stringify(opciones));
    return opciones;
  }

export const Precalificadores = ({
  nombreCampo,
  updateValue,
  nuevoValue,
  disabled,
  campoIndex,
}) => {
  const [datos, setDatos] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [error, setError] = useState("");
  const [precalificador, setPrecalificador] = useState(null);

  useEffect(() => {
    if (cargandoDatos == false) {
      setCargandoDatos(true);
      cargar().then((opciones) => {
        setDatos(opciones);
        if (
          opciones != null &&
          typeof nuevoValue != "undefined" &&
          nuevoValue != null
        ) {
          if (
            precalificador == null ||
            (precalificador != null && precalificador.value != nuevoValue)
          ) {
            const opcion = opciones.find((d) => d.value == nuevoValue);
            if (opcion != null) {
              console.log(
                "NuevoValue - setPrecalificador - " + JSON.stringify(opcion)
              );
              setPrecalificador(opcion);
              if (campoIndex != null) {
                updateValue(nombreCampo, opcion.value, campoIndex);
              } else {
                updateValue(nombreCampo, opcion.value);
              }
            } else {
              setPrecalificador(opciones[0]);
              if (campoIndex != null) {
                updateValue(nombreCampo, opciones[0].value, campoIndex);
              } else {
                updateValue(nombreCampo, opciones[0].value);
              }
            }
          }
        } else {
          setPrecalificador(opciones[0]);
          if (campoIndex != null) {
            updateValue(nombreCampo, opciones[0].value, campoIndex);
          } else {
            updateValue(nombreCampo, opciones[0].value);
          }
        }
        setCargandoDatos(false);
      });
    }
  }, []);

  useEffect(() => {
    if (datos != null && nuevoValue != null) {
      console.log('el nuevo value de bryan',nuevoValue);
      const opcion = datos.find((d) => d.value == nuevoValue);
      if (opcion != null) {
        setPrecalificador(opcion);
      }
    }
  }, [nuevoValue]);

  return (
    <Select
      isDisabled={disabled}
      value={precalificador}
      name={nombreCampo}
      onChange={(choice) => {
        if (campoIndex != null) {
          updateValue(nombreCampo, choice.value, campoIndex);
        } else {
          updateValue(nombreCampo, choice.value);
        }
        setPrecalificador(choice);
      }}
      placeholder="Seleccione un precalificador"
      options={
        cargandoDatos ? [{ value: "", label: "Cargando datos..." }] : datos
      }
    />
  );
};
